<template>
  <MultiAlert
    v-for="error in nonFieldErrors"
    :key="error.$uid"
    class="mt-2"
    :type="AlertTypes.ERROR"
  >
    {{ error.$message }}
  </MultiAlert>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { AlertTypes } from "@/interfaces/component/alert.interface.ts"
import MultiAlert from "@/components/alerts/MultiAlert.vue"

const v$: any = defineModel({ required: true })

// Only show form-level (non-field) errors here. Field-specific errors carry a
// `$property` (the field name) and are already shown inline next to their input.
// Form-level validators (registered under the root `$validator` key) have no
// `$property`, so we filter on that.
const nonFieldErrors = computed(() =>
  (v$.value.$errors ?? []).filter((error: any) => !error.$property)
)
</script>

<style scoped></style>
